import { connect } from 'react-redux';
import ComposeQuestions from '../components/ComposeQuestions';
import Questions from '../components/Questions';
import actions from '../actions/index';
export const QuestionsContainer = connect(state => ({
  state
}), actions)(Questions);
export const ComposeQuestionsContainer = connect(state => ({
  state
}), actions)(ComposeQuestions);